export const EXTERNAL_FRAMEWORKS = {
  angular: 'angular',
  vue: 'vue',
  react: 'react',
};
